export default function (instance) {
  return {
    getTrainersList() {
      return instance.get("/trainers/get/");
    },
    deleteTrainer(trainerId) {
      return instance.delete(`/trainers/delete/${trainerId}`);
    },
    getBirthdays(params) {
      return instance.get("/v2/trainers/birthdays", {params: params});
    }
  };
}
